/* eslint-disable */

import { constantRoutes } from '@/router'
import { setRoutesCut } from '@/utils/auth'
import { staffPermissionList } from '@/api/user'
import Layout from '@/layout'
import companyDataScreen from '@/views/companyDataScreen/companyDataScreen'
import projectLargeScreen from '@/views/projectLargeScreen/projectLargeScreen'

const state = {
  routes: [],
  addRoutes: [],
  userPermissionLists: [],
  routesCut: 0, //页面索引下标
  PermissionRouter: [],
  userPermissionItemLists: [],
}

const mutations = {
  SET_ROUTES: (state, routes) => {
    const noShowRoute = ['/personalCenter']
    state.addRoutes = routes

    state.routes = constantRoutes.concat(routes.filter(item => !noShowRoute.includes(item.path)))
  },
  SET_USERPERMISSIONLISTS: (state, userPermissionLists) => {
    state.userPermissionLists = userPermissionLists || []
  },
  SET_ROUTESCUT(state, routesCut) {
    setRoutesCut(routesCut)
    state.routesCut = routesCut || 0
  },
  SET_PERMISSIONROUTER(state, PermissionRouter) {
    state.PermissionRouter = PermissionRouter
  },
  SET_USERPERMISSIONITEMLISTS(state, value) {
    state.userPermissionItemLists = value || []
  },
}

const actions = {
  generateRoutes({ commit }, index) {
    return new Promise((resolve, reject) => {
      staffPermissionList({ deviceType: 1 })
        .then(({ data }) => {
          if (!data) return resolve([])

          const accessedRoutes = []
          commit('SET_USERPERMISSIONITEMLISTS', data.permissionItemList)
          data = data?.userAppPermissions.filter(item => item.appData && item.appData.length > 0)
          commit('SET_USERPERMISSIONLISTS', data)

          data[index].appData.forEach(item => {
            if (item.component && item.path) {
              const alwaysShowRoute = ['projectLargeScreen', 'contractPayment', 'companyDataScreen', 'homeIndex', 'business', 'index', 'studentManagement', 'violationDeclaration']
              let newName = item.name.replace('小区', '项目')
              const route = {
                path: '/' + (item.path || ''),
                component: item.path === 'projectLargeScreen' ? projectLargeScreen : item.path === 'companyDataScreen' ? companyDataScreen : Layout,
                redirect: `${item.path ? `/${item.path}` : ''}/${item.permissionEntityWithChildList[0].path}`,
                meta: { title: this.state.user.tenant == 1 ? newName : item.name, icon: item.icon || '', noCache: true },
                alwaysShow: !alwaysShowRoute.includes(item.path), //一直显示根路由
                children: [],
              }
              item.permissionEntityWithChildList.forEach(ele => {
                let flag = route.children.find(e => e.path === ele.path)
                let childrenNewName = ele.name.replace('小区', '项目')
                if (flag === undefined) {
                  route.children.push({
                    path: ele.path,
                    name: ele.path,
                    component: resolve => require([`@/views${item.path ? `/${item.path}` : ''}/${ele.component}`], resolve),
                    meta: {
                      title: this.state.user.tenant == 1 ? childrenNewName : ele.name,
                      icon: '',
                      noCache: true,
                      permissionItemList: ele.permissionItemList,
                      affix: ele.path === 'index',
                    },
                  })
                }
              })

              accessedRoutes.push(route)
            }
          })
          accessedRoutes.push({ path: '*', redirect: '/404', hidden: true })
          commit('SET_ROUTES', accessedRoutes)
          resolve(accessedRoutes)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  generateRoutesCut({ commit }, e) {
    commit('SET_ROUTESCUT', e)
  },

  findIndexByPath({ commit, dispatch }, path) {
    for (let i = 0; i < state.userPermissionLists.length; i++) {
      const appData = state.userPermissionLists[i].appData

      for (let j = 0; j < appData.length; j++) {
        if (appData[j].path == path) {
          commit('SET_ROUTESCUT', i)
          dispatch('generateRoutes', i)
        }
      }
    }
  },

  ArrayAnalyzer({ commit, dispatch }) {},
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
}
